module.exports = __webpack_public_path__ + "img/etuglogo-retina-min.ceb2fa0b.png";